import React from 'react';
import { useHistory } from 'react-router';

//collections
import TableWithSearch from '../../../../blockGroups/table/TableWithSearch/TableWithSearch.blockgroup';

// utils
import { useTableSort } from '../../../../shared/hooks/useTableSort';
import { checkIfUserHasGroup, createUserGroupList } from '../../../../shared/privileges/userGroups';

const equipmentListSearchFieldOptions = [
    {value: "sku", title: "SKU"},
    {value:"name", title:"Name" },
    {value: "category.name", title: "Category"}
]

const equipmentListColumnConfigs = [
    {
        name: "sku",
        title: "SKU",
        objectFieldsToDisplay: ["sku"],
        objectFieldsDelimeter: "",
        useNestedObject: false
    },
    
    {
        name: "name",
        title: "Name",
        objectFieldsToDisplay: ["name"],
        objectFieldsDelimeter: "",
        useNestedObject: false
    },

    {
        name: "category",
        title: "Category",
        objectFieldsToDisplay: ["category.name"],
        objectFieldsDelimeter: "",
        useNestedObject: true
    },
    {
        name: "weight",
        title: "Weight (lbs)",
        objectFieldsToDisplay: ["itemWeightInLbs"],
        objectFieldsDelimeter: "",
        width: 250,
        useNestedObject: false
    },
    {
        name: "quantity",
        title: "Quantity",
        objectFieldsToDisplay: ["quantity"],
        objectFieldsDelimeter: "",
        width: 250,
        useNestedObject: false,
        type: 'number',
        align: 'left',
        headerAlign: 'left'
    },
    
]

const EquipmentSearchListWithSearch = ({data ={allEquipment:[]}, loading, error, onAddClick, pageProps }) => {
    const history = useHistory()
    const handleRowClick = (rowData) => {
        history.push(`/inventory/equipment/${rowData.id}`)
    }

    const sortModel = useTableSort(pageProps.location.search)
    const handleSortChange = (newSortModel) => {
        if(newSortModel.length > 0) {
            history.push(`/inventory/equipment?sortField=${newSortModel[0].field}&sortDirection=${newSortModel[0].sort}`)
        } else {
            history.push(`/inventory/equipment?sortField=${""}&sortDirection=${""}`)
        }
    }

    const addButtonConfig = {
        text: "New Equipment",
        onClick: onAddClick
    }
    
    

    return<TableWithSearch
        rawData={data.allEquipment}
        loading={false}
        error={error}
        searchFieldOptions={equipmentListSearchFieldOptions}
        columnConfigs={equipmentListColumnConfigs}
        onRowClick={handleRowClick}
        addButtonConfig={addButtonConfig}
        sortModel={sortModel}
        onSortModelChange={handleSortChange}
        pageProps={pageProps}
    />
}

export default EquipmentSearchListWithSearch;